import React from 'react';
import { LESSON_ACTION_IMAGES as images } from '../../lib/lessonActionImages';

export default function LessonActionIcon({ action, className = '', style }) {
  if (!images[action]) return null;
  return <img src={images[action]} alt="" aria-hidden="true" draggable={false}
    className={`inline-block shrink-0 object-contain align-middle ${className}`}
    style={style} />;
}
